import axios from 'axios';
import { ROLES, HOSTSERVER, PAQUETE, DOCS, TIPO_PLAN } from '@/constants/global';
import authService from './auth.service';

const myInterceptor = (config) => {
  if (authService.isLoggedIn) {
    const token = authService.getToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}
axios.interceptors.request.use(myInterceptor);

async function getData() {
  try {
    const response = await axios.get('https://jsonplaceholder.typicode.com/posts');
    return response.data;
  } catch (error) {
    console.error(error);
  }
}
let handleError = (error) => {
  console.error(error);
  return (error && error.response && error.response.data) || error;
}
let login = async (obj) => {
  try {
    const url = `${HOSTSERVER}/api/v1/login`;
    const response = await axios.post(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getUsuarios = async (filtro,page,size, estado) => {
  try {
    let params = {page,filtro,size,estado};
    const url = `${HOSTSERVER}/api/v1/usuarios`;
    const response = await axios.get(url, {params: params});
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let createUsuario = async (obj) => {
  try {
    const url = `${HOSTSERVER}/api/v1/usuarios`;
    const response = await axios.post(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let updateUsuario = async (id,obj) => {
  try {
    const url = `${HOSTSERVER}/api/v1/usuarios/${id}`;
    const response = await axios.put(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let updateDatosDeUsuario = async (obj) => {
  try {
    const url = `${HOSTSERVER}/api/v1/datos/usuarios`;
    const response = await axios.put(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getUsuarioPorId = async (id) => {
  try {
    const url = `${HOSTSERVER}/api/v1/usuarios/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getRoles = async () => {
  try {
    return await ROLES;
  } catch (error) {
    throw handleError(error);
  }
}
let getPaquetes = async () => {
  try {
    return await PAQUETE;
  } catch (error) {
    throw handleError(error);
  }
}
let getDocumentos = async () => {
  try {
    return await DOCS;
  } catch (error) {
    throw handleError(error);
  }
}
let getTipoPlanes = async () => {
  try {
    return await TIPO_PLAN;
  } catch (error) {
    throw handleError(error);
  }
}
//Contratos
let uploadPago = async (formData) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/archivos/pagos`;
    const response = await axios.post(url,formData);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let uploadLogo = async (formData) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/archivos/logos`;
    const response = await axios.post(url,formData);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let uploadCapturaPse = async (formData) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/archivos/capturas/pse`;
    const response = await axios.post(url,formData);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let uploadPagoContrato = async (idcontrato,formData) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/contratos/${idcontrato}/pagos`;
    const response = await axios.post(url,formData);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let createContrato = async (obj) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/contratos`;
    const response = await axios.post(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getContratos = async (filtro,page,size, estado) => {
  try {
    let params = {page,filtro,size,estado};
    const url = `${HOSTSERVER}/api/v1/contratos`;
    const response = await axios.get(url, {params: params});
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}

let updateContrato = async (id,obj) => {
  try {
    const url = `${HOSTSERVER}/api/v1/contratos/${id}`;
    const response = await axios.put(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getContratoPorId = async (id) => {
  try {
    const url = `${HOSTSERVER}/api/v1/contratos/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getContratoPorRuc = async (ruc) => {
  try {
    const url = `${HOSTSERVER}/api/v1/contratos/${ruc}/detalles`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let updateContratoRegistro = async (obj) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/contratos/${obj.IdContrato}/registros`;
    const response = await axios.post(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let updateEstadoTerminoContrato = async (obj) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/contratos/${obj.IdContrato}/terminos`;
    const response = await axios.post(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}

//CONTADORES
let createContador = async (obj) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/contadores`;
    const response = await axios.post(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let updateContador = async (id,obj) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/contadores/${id}`;
    const response = await axios.put(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getContadorPorId = async (id) => {
  try {
    const url = `${HOSTSERVER}/api/v1/contadores/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getContadorPorDocumento = async (documento) => {
  try {
    const url = `${HOSTSERVER}/api/v1/contadores/documentos/${documento}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}

// recomendados

let createRecomendado = async (obj) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/recomendados`;
    const response = await axios.post(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let updateRecomendado = async (id,obj) =>{
  try {
    const url = `${HOSTSERVER}/api/v1/recomendados/${id}`;
    const response = await axios.put(url,obj);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}
let getRecomendadoPorId = async (id) => {
  try {
    const url = `${HOSTSERVER}/api/v1/recomendados/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}

let getDatosSunat = async (id) => {
  try {
    const url = `${HOSTSERVER}/api/v1/sunat/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
}

export default {
  getData,
  login,
  getUsuarios,
  createUsuario,
  updateUsuario,
  updateDatosDeUsuario,
  getUsuarioPorId,
  getRoles,
  getPaquetes,
  getDocumentos,
  getTipoPlanes,
  uploadPago,
  createContrato,
  getContratos,
  updateContrato,
  getContratoPorId,
  uploadPagoContrato,
  getContratoPorRuc,
  uploadLogo,
  uploadCapturaPse,
  updateContratoRegistro,
  updateEstadoTerminoContrato,
  createContador,
  getContadorPorId,
  updateContador,
  getContadorPorDocumento,
  createRecomendado,
  getRecomendadoPorId,
  updateRecomendado,
  getDatosSunat
}